export const routes = {
    services: [
        { title: 'CAHPS Surveys', link: 'https://public.cssresearch.org/cahps'},
        { title: 'Member Experience Surveys', link: 'https://public.cssresearch.org/member-experience'},
        { title: 'Provider Satisfaction Surveys', link: 'https://public.cssresearch.org/provider-surveys'},
        { title: 'Patient Experience Surveys', link: 'https://public.cssresearch.org/patient-experience'},
        { title: 'Provider Directories', link: 'https://public.cssresearch.org/provider-directory-services'},
        { title: 'Health Plan Decision Support Tools', link: '/decision-support-tools'},
    ],
    solutions: [
        { title: 'Services for Health Plans', link: 'https://public.cssresearch.org/health-plans'},
        { title: 'Healthcare Providers', link: 'https://public.cssresearch.org/healthcare-providers'},
        { title: 'Government Agencies', link: 'https://public.cssresearch.org/government-agencies'},
        { title: 'CAHPS Surveys', link: 'https://public.cssresearch.org/cahps'},
        { title: 'Research Partners', link: 'https://public.cssresearch.org/research-partners'},
        { title: 'Consumers', link: 'https://public.cssresearch.org/consumers'},
    ],
    company: [
        { title: 'About Us', link: 'https://public.cssresearch.org/about'},
        { title: 'Leadership', link: 'https://public.cssresearch.org/leadership'},
        { title: 'Security Controls', link: 'https://public.cssresearch.org/security-controls'},
        { title: 'Careers', link: 'https://cssresearch.applicantpro.com/jobs/'},
        { title: 'Contact Us', link: 'https://public.cssresearch.org/contact-us'},
        { title: 'Account Login', link: 'https://public.cssresearch.org/login'},
    ]
};